export default {
    share: null,
};



// WEBPACK FOOTER //
// ./src/store/share/state.js